module.exports = __webpack_public_path__ + "img/7.b65597b9.jpg";